import $ from 'jquery';

import '../../../scss/app/congregation_list.scss';

const $filterButton = $('.congregation-list-filter__button');

function closeDropdowns() {
  $filterButton.attr('aria-expanded', false);
  $filterButton.next().attr('hidden', true);
}

$filterButton.on('click', (ev) => {
  ev.stopImmediatePropagation();
  ev.stopPropagation();

  const $button = $(ev.currentTarget);
  const state = $button.attr('aria-expanded') === 'true' || false;

  $button.attr('aria-expanded', !state);
  $button.next().attr('hidden', state);
});

$(document).on('click', closeDropdowns);
